export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11387.c75c111a.jpg";